import {FC} from 'react';

import Companies from '../../components/Companies/Companies';

const ClientsPage: FC = () => {
  return (
    <div>
      <Companies />
    </div>
  );
};

export default ClientsPage;
